import { MouseEvent } from 'react'
import { Typography } from '@mui/material'
// helper
import { showHashtagMenu } from '$comp/modals/menus/hashtag-menu'
import { roomSearchApi } from '$comp/_app/components/chat/room'

export function hashtagRenderer(key: string, result: string[]) {
  const hashtag = result[0]
  return (
    <Typography
      key={key}
      variant="paragraph3"
      color="var(--hyper-text-color)"
      sx={{ cursor: 'pointer', fontSize: '14px', unicodeBidi: 'normal' }}
      onContextMenu={(e: MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
        showHashtagMenu({ hashtag })
      }}
      onClick={() => roomSearchApi.handleSearch(hashtag)}
      dir="auto"
    >
      {hashtag}
    </Typography>
  )
}
